import React, { useEffect  } from 'react'
import { Routes, Route } from 'react-router-dom';
//import './../assets/style.css';
import './../assets/css/flaticon.min.css';
import '../assets/css/style.css';
import '../assets/css/skin/skin-1.css';
import "@fontsource/roboto"; // 
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout';
import Home from '../routes/Home';
import About from '../routes/About';
import Vision from '../routes/Vision';
import Campus from '../routes/Campus';
import Facility from '../routes/Facility';
import ClassRooms from '../routes/ClassRooms';
import Sports from '../routes/Sports';
import Library from '../routes/Library';
import Labs from '../routes/Labs';
import Transport from '../routes/Transport';
import MusicDance from '../routes/MusicDance';
import ArtCraft from '../routes/ArtCraft';
import Tour from '../routes/Tour';
import Contact from '../routes/Contact';
import Gallery from '../routes/Gallery';
import VideoGallery from '../routes/VideoGallery';
import Addmission from '../routes/Addmission';
import Management from '../routes/Management';
import News from '../routes/News';
import Events from '../routes/Events';
import Staff from '../routes/Staff';
import Staff1 from '../routes/Staff1';
import Fee from '../routes/Fee';
import AddmissionPolicy from '../routes/AddmissionPolicy';
import Error500 from '../routes/Error500';
const App = () => {
	useEffect(() => {		     
 		 window.scrollTo(0, 0);
		 document.title = `${process.env.REACT_APP_SITE_TITLE}`;
	}, [])
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home radius='radius' />} />
          <Route path="/about" element={<About />} />
		  <Route path="/vision" element={<Vision />} />
		  <Route path="/campus" element={<Campus />} />
          <Route path="/facility" element={<Facility />} />
		  <Route path="/classrooms" element={<ClassRooms />} />
		  <Route path="/sports" element={<Sports />} />
		  <Route path="/library" element={<Library />} />
		  <Route path="/labs" element={<Labs />} />
		  <Route path="/transport" element={<Transport />} />
		  <Route path="/music&dance" element={<MusicDance />} />
		  <Route path="/art&craft" element={<ArtCraft />} />
		  <Route path="/tour" element={<Tour />} />		  
		  <Route path="/contact" element={<Contact />} />
		  <Route path="/gallery" element={<Gallery />} />
		  <Route path="/addmission" element={<Addmission />} />		  
		  <Route path="/leadership&management" element={<Management />} />
		  <Route path="/teaching_staff" element={<Staff />} />
		  <Route path="/news" element={<News />} />
		  <Route path="/events" element={<Events />} />		  
		  <Route path="/teaching_staff" element={<Staff />} />
		  <Route path="/non_teaching_staff" element={<Staff1 />} />		  
		  <Route path="/fee" element={<Fee />} />
		  <Route path="/addmissionpolicy" element={<AddmissionPolicy />} />		  
		  <Route path="/photogallery" element={<Gallery />} />
		  <Route path="/videogallery" element={<VideoGallery />} />		  
          <Route path="*" element={<Error500 />} />
        </Route>
      </Routes>
    </>
  );
};
export default App;